import React, { useEffect, useState } from "react";
import axios from "axios";
import { createScenarioData, updateScenarioData } from "../api/scenarioData";
import ActiveStatusFilter from "../components/shared/ActiveStatusFilter";

export default function AssetManager() {

  const [assets, setAssets] = useState([]);
  const [assetTypes, setAssetTypes] = useState([]);
  const [owners, setOwners] = useState([]);

  const [editingId, setEditingId] = useState(null);

  const [message, setMessage] = useState(null);
  const [showActive, setShowActive] = useState(true);

  const [form, setForm] = useState({
    name: "",
    asset_type_ref: "",
    business_owner: "",
    criticality: "Medium",
    description: "",
    is_active: true,
  });

  const showMessage = (type, text) => {

    setMessage({
      type,
      text,
    });

    setTimeout(() => {
      setMessage(null);
    }, 4000);
  };

  const loadAssets = async () => {

    const res = await axios.get(
      "/api/digital-risk/assets/"
    );
    setAssets(res.data);
  };

  const loadAssetTypes = async () => {
    const res = await axios.get(
      "/api/digital-risk/asset-types/"
    );

    setAssetTypes(res.data);
  };

  const loadOwners = async () => {
    const res = await axios.get(
      "/api/digital-risk/risk-owners/"
    );

    setOwners(res.data);
  };

  useEffect(() => {

    loadAssets();
    loadAssetTypes();
    loadOwners();

  }, []);

  const payload = {
    ...form,
    asset_type: form.asset_type_ref,
  };

  const saveAsset = async () => {

    try {

      if (!form.name.trim()) {

        showMessage(
          "error",
          "Asset name is required."
        );

        return;
      }

      if (!form.asset_type_ref) {

        showMessage(
          "error",
          "Business process is required."
        );

        return;
      }

      if (editingId) {

        await updateScenarioData("assets", editingId, payload);

        showMessage(
          "success",
          "Asset updated successfully."
        );

      } else {

        await createScenarioData("assets", payload);

        showMessage(
          "success",
          "Asset created successfully."
        );
      }

      setEditingId(null);

      setForm({
        name: "",
        asset_type_ref: "",
        business_owner: "",
        criticality: "Medium",
        description: "",
        is_active: true,
      });

      loadAssets();

    } catch (error) {

      console.error(
        error.response?.data || error
      );

      showMessage(
        "error",
        "Unable to save asset."
      );
    }
  };

  const editAsset = (asset) => {

    setEditingId(asset.id);

    setForm({
      name: asset.name,
      asset_type_ref: asset.asset_type_ref || "",
      business_owner: asset.business_owner || "",
      criticality: asset.criticality || "Medium",
      description: asset.description || "",
      is_active: asset.is_active,
    });
  };

  return (

    <div className="p-6 space-y-6">
      {/*  
      <div className="bg-sky-950 text-white rounded-3xl p-7 shadow-sm">
        <p className="text-xs uppercase tracking-[0.25em] text-slate-400">
          Scenario Modeling
        </p>

        <div className="flex flex-col xl:flex-row xl:items-end xl:justify-between gap-6 mt-3">
          <div>
            <h1 className="text-3xl font-bold">
              Asset Manager
            </h1>

            <p className="text-slate-300 mt-2 max-w-3xl">
              Manage critical digital assets used in FAIR risk scenarios.
            </p>
          </div>

        </div>
      </div>
      */}
      {message && (

        <div
          className={`
            px-4
            py-3
            rounded-xl
            text-sm
            font-medium

            ${
              message.type === "success"
                ? "bg-green-100 text-green-800 border border-green-200"
                : "bg-red-100 text-red-800 border border-red-200"
            }
          `}
        >
          {message.text}
        </div>
      )}

      <div className="bg-white border rounded-2xl p-5">

        <h2 className="font-semibold mb-4">

          {editingId
            ? "Edit Asset"
            : "New Asset"}

        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          <input
            value={form.name}
            onChange={(e) =>
              setForm({
                ...form,
                name: e.target.value,
              })
            }
            placeholder="Asset name"
            className="border rounded-xl px-4 py-3"
          />

          <select
            value={form.asset_type_ref}
            onChange={(e) =>
              setForm({
                ...form,
                asset_type_ref: e.target.value,
              })
            }
            className="border rounded-xl px-4 py-3"
          >
            <option value="">
              Select business process
            </option>

            {assetTypes.map((type) => (

              <option
                key={type.id}
                value={type.id}
              >
                {type.name}
              </option>
            ))}
          </select>

          <select
            value={form.business_owner}
            onChange={(e) =>
              setForm({
                ...form,
                business_owner: e.target.value,
              })
            }
            className="border rounded-xl px-4 py-3"
          >

            <option value="">
              Select business owner
            </option>

            {owners
              .filter((owner) => owner.active)
              .map((owner) => (

                <option
                  key={owner.id}
                  value={owner.name}
                >
                  {owner.name}
                </option>

            ))}

          </select>

          <select
            value={form.criticality}
            onChange={(e) =>
              setForm({
                ...form,
                criticality: e.target.value,
              })
            }
            className="border rounded-xl px-4 py-3"
          >
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
            <option value="Critical">Critical</option>
          </select>

          <textarea
            value={form.description}
            onChange={(e) =>
              setForm({
                ...form,
                description: e.target.value,
              })
            }
            placeholder="Description"
            className="border rounded-xl px-4 py-3 md:col-span-2"
            rows={4}
          />

          <label className="flex items-center gap-2 text-sm">

            <input
              type="checkbox"
              checked={form.is_active}
              onChange={(e) =>
                setForm({
                  ...form,
                  is_active: e.target.checked,
                })
              }
            />

            Active

          </label>

        </div>

        <div className="flex gap-3 mt-5">

          <button
            onClick={saveAsset}
            className="
              bg-slate-900
              text-white
              px-5
              py-3
              rounded-xl
            "
          >
            {editingId
              ? "Update"
              : "Create"}
          </button>

          {editingId && (

            <button
              onClick={() => {

                setEditingId(null);

                setForm({
                  name: "",
                  asset_type_ref: "",
                  business_owner: "",
                  criticality: "Medium",
                  description: "",
                  is_active: true,
                });
              }}
              className="
                border
                px-5
                py-3
                rounded-xl
              "
            >
              Cancel
            </button>
          )}
        </div>
      </div>

      <div className="bg-white border rounded-2xl p-5">

        <h2 className="font-semibold mb-4">
          Assets
        </h2>
        <ActiveStatusFilter value={showActive} onChange={setShowActive} />

        <table className="w-full text-sm">

          <thead>

            <tr className="border-b text-gray-500">

              <th className="text-left py-3">
                Asset
              </th>

              <th className="text-left py-3">
                Business Process
              </th>

              <th className="text-left py-3">
                Criticality
              </th>

              <th className="text-left py-3">
                Status
              </th>

              <th className="text-left py-3">
                Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {assets.filter((asset) => asset.is_active === showActive).map((asset) => (

              <tr
                key={asset.id}
                className="border-b"
              >

                <td className="py-3 font-medium">
                  {asset.name}
                </td>

                <td className="py-3">
                  {asset.asset_type_name}
                </td>

                <td className="py-3">
                  {asset.criticality}
                </td>

                <td className="py-3">
                  {asset.is_active
                    ? "Active"
                    : "Inactive"}
                </td>

                <td className="py-3">

                  <button
                    onClick={() =>
                      editAsset(asset)
                    }
                    className="
                      text-slate-700
                      hover:text-black
                    "
                  >
                    Edit
                  </button>

                </td>

              </tr>
            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
}
